// Clinic-queue service — exposes the live queue position for in-clinic
// (sessionMode === 'OFFLINE') booked events scheduled for today.
//
// Backend (planned): GET /api/secure/me/clinic-queue/{eventId} →
//   ClinicQueueStatus {
//     eventId, sessionMode='OFFLINE',
//     chamberRoomName, chamberRoomId, practitionerId, practitionerName,
//     yourAppointmentNumber,        // 1-based slot in today's queue at this room
//     yourScheduledAt, yourDurationMinutes,
//     currentAppointmentNumber,     // slot the practitioner is presently seeing
//                                   // (null if the day hasn't begun)
//     currentSessionStartedAt,      // when current slot started — null pre-clinic
//     totalAppointmentsToday,
//     estimatedWaitMinutes,         // sum of remaining durations until your slot
//     averageDurationMinutes,       // for richer "+/-" copy
//     serverTime,                   // for clock-skew correction
//   }
//
// The patient-portal initiative is mock-first (PLAN §5) — the contract above is
// implemented in mockApi/clinicQueueApi.js so the F* drops land independently
// of the matching backend phase. Cutover is the same per-resource flag flip.
//
// The card widget polls this every 30s while the queue card is mounted; a
// follow-up phase will replace polling with Agora signal pushes per the
// patient-portal plan.

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/clinicQueueApi'
import { patientGet } from './patientApi'

const PATH = '/api/secure/me/clinic-queue'

export async function getQueueStatus(profile, eventId) {
  if (!eventId) return null
  if (shouldUseMocks()) return mock.getQueueStatus(profile, eventId)
  // patientId query param is appended by patientApi.buildParams.
  const res = await patientGet(`${PATH}/${encodeURIComponent(eventId)}`, {
    requirePatientContext: true,
    profileId: profile?.id,
  })
  return res?.data || null
}
